import React from 'react';
import { CustomColumn, NumericalColumn, StringColumn } from 'baseui/data-table';
import { EMPTY_STRING, GLOBAL_THEME } from 'commons-ui';
import { useStyletron } from 'baseui';
import _toLower from 'lodash/toLower';
import { EVENT_STATUS } from '../constants';

export const COL_NAMES = {
	eventTime: 'eventTime',
	networkEvent: 'networkEvent',
	gameEvent: 'gameEvent',
	score: 'score',
	tokenPositions: 'tokenPositions',
	ipAddress: 'ipAddress',
	appVersion: 'appVersion',
	networkType: 'networkType',
	disconnectionReason: 'disconnectionReason',
	isConnected: 'isConnected',
	isRejoined: 'isRejoined',
	socketType: 'socketType',
	boardtokenpositions: 'boardtokenpositions',
	roundNo: 'roundNo',
	multiplier: 'multiplier'
};

export const columnConfigs = [
	StringColumn({
		title: 'Event time',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.eventTime]
	}),
	CustomColumn({
		title: 'Network event',
		maxWidth: 300,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.networkEvent],
		renderCell: (params: any) => {
			const { value } = params;
			let textColor = GLOBAL_THEME.Colors.black;
			const lowerCaseValue = _toLower(value);
			const [css] = useStyletron();

			if (lowerCaseValue === EVENT_STATUS.CLIENT_CONNECTED) {
				textColor = GLOBAL_THEME.Colors.textGreen;
			} else if (lowerCaseValue === EVENT_STATUS.CLIENT_DISCONNECTED) {
				textColor = GLOBAL_THEME.Colors.textRed;
			}

			return (
				<div
					className={css({
						width: '100%',
						height: '100%',
						color: textColor
					})}>
					{value}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Game event',
		maxWidth: 300,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.gameEvent]
	}),
	NumericalColumn({
		title: 'Score',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.score] || 0
	}),
	StringColumn({
		title: 'Token position',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.tokenPositions]
	}),
	StringColumn({
		title: 'Ip address',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.ipAddress]
	}),
	StringColumn({
		title: 'App version',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.appVersion]
	}),
	StringColumn({
		title: 'Network type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.networkType]
	}),
	CustomColumn({
		title: 'Disconnection reason',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.disconnectionReason],
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 30) {
				descriptionCompress = `${value.substr(0, 30)}...`;
			} else {
				descriptionCompress = value;
			}
			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	StringColumn({
		title: 'Is Connected',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.isConnected]
	}),
	StringColumn({
		title: 'Is Rejoined',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.isRejoined]
	}),
	StringColumn({
		title: 'Socket type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.socketType]
	}),
	CustomColumn({
		title: 'Board Token Positions',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.boardtokenpositions] ? JSON.stringify(JSON.parse(data[COL_NAMES.boardtokenpositions])) : EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let compressValue = '';
			if (value.length > 30) {
				compressValue = `${value.substr(0, 30)}...`;
			} else {
				compressValue = value;
			}
			return <div title={value}>{compressValue}</div>;
		}
	})
];

export const tcnxColumnConfigs = [
	StringColumn({
		title: 'Event time',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.eventTime]
	}),
	CustomColumn({
		title: 'Network event',
		maxWidth: 300,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.networkEvent],
		renderCell: (params: any) => {
			const { value } = params;
			let textColor = GLOBAL_THEME.Colors.black;
			const lowerCaseValue = _toLower(value);
			const [css] = useStyletron();

			if (lowerCaseValue === EVENT_STATUS.CLIENT_CONNECTED) {
				textColor = GLOBAL_THEME.Colors.textGreen;
			} else if (lowerCaseValue === EVENT_STATUS.CLIENT_DISCONNECTED) {
				textColor = GLOBAL_THEME.Colors.textRed;
			}

			return (
				<div
					className={css({
						width: '100%',
						height: '100%',
						color: textColor
					})}>
					{value}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Game event',
		maxWidth: 300,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.gameEvent]
	}),
	NumericalColumn({
		title: 'Score',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.score] || 0
	}),
	StringColumn({
		title: 'Round Number',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.roundNo] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Score Multiplier',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.multiplier] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Ip address',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.ipAddress]
	}),
	StringColumn({
		title: 'App version',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.appVersion]
	}),
	StringColumn({
		title: 'Network type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.networkType]
	}),
	CustomColumn({
		title: 'Disconnection reason',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.disconnectionReason],
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 30) {
				descriptionCompress = `${value.substr(0, 30)}...`;
			} else {
				descriptionCompress = value;
			}
			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	StringColumn({
		title: 'Is Connected',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.isConnected]
	}),
	StringColumn({
		title: 'Is Rejoined',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.isRejoined]
	}),
	StringColumn({
		title: 'Socket type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.socketType]
	})
];
